import React from "react";
import styled from "styled-components/macro";

const Select = styled.select`
        height: ${props => props.height ? props.height : '35px'};
        width: ${props => props.width ? props.width : '250px'};
        margin: ${props => props.margin ? props.margin : '0px 0px 0px 0px'};
        padding: ${props => props.padding ? props.padding : '0px 0px 0px 10px'};
        color: ${props => props.color ? props.color : '#4a4a4a'};
        border: ${props => props.border ? props.border : '1px solid'};
        border-color: ${props => props.borderColor ? props.borderColor : 'rgb(187, 187, 187)'};
        border-radius: ${props => props.borderRadius ? props.borderRadius: '5px'};
        font-size: ${props => props.fontSize ? props.fontSize: '16px'};
    `;

function DropdownSelector(props) {

    const options = props.options ? props.options : [];
    const defaultValue = props.defaultValue ? props.defaultValue : '';
    const disabled = props.disabled ? props.disabled : false;

    const findByValue = (value) => {
        const idx = options.findIndex((e) => value === e.value);
        if(idx === -1)return null;
        return options[idx];
    }

    const handleChange = (opt) => {
        if(opt)props.handleChange(opt.id);
    }

    if(props.searchEnabled 
        && options.length > 0 
        && typeof options[0] !== 'undefined'){
        return(
            <Select 
                className={props.className}
                onChange={(e) => handleChange(findByValue(e.target.value))}
                placeholder={'hola!'}
                defaultValue={defaultValue}
            >
                {options.map((o) => {
                    return (
                        <option key={o.id} value={o.value}>
                            {o.value}
                        </option>
                        )
                })}
            </Select>
      )
    }
    return (
        <Select
            id={props.id ? props.id : null}
            className={props.className}
            disabled={disabled}
            onChange={(e) => props.handleChange(e.target.value)}
            value={defaultValue}
        >
        {options.length === 0 ? (
            <option disabled defaultValue>
              Loading...
            </option>
        ) : (
          options.map((o) => (
              <option key={o.id} value={o.id}>
                  {o.value}
              </option>
          ))
        )}
        </Select>
    );
}

export default DropdownSelector;